import { useCurrentPaymentTask } from '@/providers/PaymentTaskProvider';

export const ContractAlert = () => {
  const { paymentTask: task } = useCurrentPaymentTask();

  if (task!.is_contracted_project) {
    return <></>;
  } else {
    return (
      <div className="alert alert-warning text-white" role="alert">
        <span className="alert-icon">
          <i className="fas fa-exclamation-triangle"></i>
        </span>
        <span className="alert-text text-sm">このプロジェクトは承認された契約タスクが存在しません。支払前に確認してください。</span>
      </div>
    );
  }
};
